export default "__VITE_ASSET__sSc038KB__"